export const componentIds = {
  ChartArea: 'ChartArea',
};
